export const EDITABLE_FORM_KEYS = [
    "invoiceNumber",
    "supplierName",
    "deliveryStatus",
    "received",
    "receivedDate",
    "trackingId",
    "invoiceDate",
    "invoiceAutomationUploadDate",
    "invoiceProcessedBy",
];

export function editableFormSnapshot(form) {
    const slice = {};
    for (const key of EDITABLE_FORM_KEYS) {
        slice[key] = form?.[key] ?? "";
    }
    return JSON.stringify(slice);
}
